import React from 'react'
import wavegrid from "../assets/images/wavegrid.png"
import qmax from "../assets/images/qmax.png"
import tms from "../assets/images/tms.png"
import digmagic from "../assets/images/digital.png"
import Project from './Project'
import shucks from "../assets/images/shucks.png"
import fun from '../assets/images/fun.png'

const Projects = () => {
    const works = [
        {
            id:1,
            image:wavegrid,
            url:"https://wavegrid-redesign.vercel.app/"
        },
        {
            id:2,
            image:qmax,
            url:"https://qmax.vercel.app/"
        },
        {
            id:3,
            image:tms,
            url:"https://todostms-frontend.vercel.app/"
        },
        {
            id:4,
            image:digmagic,
            url:"https://digitalmagic.vercel.app/"
        },
        {
            id:5,
            image:shucks,
            url:"https://staging-shucks-footware.vercel.app/"
        },
        {
            id:6,
            image:fun,
            url:"https://furniture-place.vercel.app/"
        }
        
    ]
  return (
    <div id="portfolio" className="font-vic main text-white w-full h-full py-6 md:py-10 px-2">
    <div className="container mx-auto w-full justify-center items-center flex flex-col  gap-4">
    <div className="flex flex-col w-full h-full">
    <div className="flex flex-col  w-full h-full gap-3 py-4">
            <p className="text-gray-600 text-[12px] md:text-[20px] font-semibold tracking-widest">SOME OF MY WORK</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 w-full gap-2">
            {works.map((work) => (
                <Project image={work.image}id={work.id} url={work.url}/>
            ))}
        </div>
        </div>
        </div>
    </div>
  )
}

export default Projects